import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { makePreviewImageSrcSelector } from "../selectors";
import Component, { type ImageGalleryImagePreviewComponentProps } from "./component";

export type ImageGalleryImagePreviewContainerProps = RootContainerProps & {
  onLoaded: () => void;
};

const makeMapStateToProps = () => {
  const previewImageSrcSelector = makePreviewImageSrcSelector();

  return (state: AppState, props: ImageGalleryImagePreviewContainerProps): ImageGalleryImagePreviewComponentProps => {
    return {
      imageSrc: previewImageSrcSelector(state, props),
      ...props
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
